/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationBrandCatalogAssignmentRequestCatalogType
 */
export interface UpdateLocationBrandCatalogAssignmentRequestCatalogType {
}

/**
 * Check if a given object implements the UpdateLocationBrandCatalogAssignmentRequestCatalogType interface.
 */
export function instanceOfUpdateLocationBrandCatalogAssignmentRequestCatalogType(value: object): value is UpdateLocationBrandCatalogAssignmentRequestCatalogType {
    return true;
}

export function UpdateLocationBrandCatalogAssignmentRequestCatalogTypeFromJSON(json: any): UpdateLocationBrandCatalogAssignmentRequestCatalogType {
    return UpdateLocationBrandCatalogAssignmentRequestCatalogTypeFromJSONTyped(json, false);
}

export function UpdateLocationBrandCatalogAssignmentRequestCatalogTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationBrandCatalogAssignmentRequestCatalogType {
    return json;
}

export function UpdateLocationBrandCatalogAssignmentRequestCatalogTypeToJSON(json: any): UpdateLocationBrandCatalogAssignmentRequestCatalogType {
    return UpdateLocationBrandCatalogAssignmentRequestCatalogTypeToJSONTyped(json, false);
}

export function UpdateLocationBrandCatalogAssignmentRequestCatalogTypeToJSONTyped(value?: UpdateLocationBrandCatalogAssignmentRequestCatalogType | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

